
import cell from '../static/images/cell.svg'
import '../App.css';

const Control = (props) => {

  return (
    <div className="card control">
      <h3 className="card-title">大棚管理</h3>
      <div className="card-body control">
        {props.houses.map((item, index) => (
          <div className="control-item" key={index}>
            <img src={cell} alt="cell" />
            <span className="name">{item.name}</span>
            <div className="total">
              <span className="area">{item.area} 平米</span>
              <span className="totalYield">{item.unit} </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Control;
